"use client";

import Link from "next/link";
import { LinkType } from "../../../sanity/lib/types/link";
import { LocalizedLink } from "./localizedLink";

export const UnstyledLink = ({ link, className }: { link: LinkType; className?: string }) => {
    if (!link) {
        return null;
    }

    if (link.type === "external") {
        if (link.label.startsWith("mailto:") || link.label.startsWith("tel:")) {
            return (
                <Link
                    href={link.external ?? ""}
                    className={`m-link-l md:d-link-l hover:no-underline ${className}`}
                >
                    {link.label}
                </Link>
            );
        }

        return (
            <Link
                href={link.external ?? ""}
                className={`m-link-l md:d-link-l hover:no-underline ${className}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {link.label}
            </Link>
        );
    }

    return (
        <LocalizedLink
            slug={link.internal?.metadata?.slug.current || ""}
            className={`m-link-l md:d-link-l hover:no-underline ${className}`}
            label={link.label}
        />
    );
};
